/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** agent-inquiry-controller */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** agent-inquiry-controller agentReplace */
export async function agentReplacePost(payload: model.IApiAgentReplaceReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryOperateResp>({
    url: `/es/api/biz/inquiry/v2/agent/replace`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** agent-inquiry-controller agentSave */
export async function agentSavePost(payload: model.IApiAgentStartReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryStartResp>({
    url: `/es/api/biz/inquiry/v2/agent/save`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** agent-inquiry-controller agentStart */
export async function agentStartPost(payload: model.IApiAgentStartReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryStartResp>({
    url: `/es/api/biz/inquiry/v2/agent/start`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}
